import api from '../../../../api/apibackend'
import Nprogress from 'nprogress'
import Vue from 'vue'
import {
    MARK_DELIVERY_AS_PAID,

    GET_DEALERS,
    GET_DEALER_DELIVERIES,
    GET_SHIPPING_RATES,
    GET_SHIPPINGS,

    CREATE_DEALER,
    UPDATE_DEALER,
    DELETE_DEALER,

    CREATE_SHIPPING_RATE,
    UPDATE_SHIPPING_RATE,
    DELETE_SHIPPING_RATE,

    GET_LINKED_COMPANIES,

    LINK_DELIVERY_COMPANY,
    UNLINK_DELIVERY_COMPANY
    
} from './actions.type'
import { FETCH_START, FETCH_END, SET_DEALERS, SET_SHIPPINGS, SET_SHIPPING_RATES, SET_LINKED_COMPANIES, SET_LINKED_STORES } from './mutations.type'
import { GET_STORE_USER_AUTH } from '../../storeModule/actions.type';

const state = {
  dealers: null,
  shippings: null,
  shippingRates: null,
  linkedCompanies: null,
  loading: false,
}

const getters = {
  dealers: state => (state.dealers ? state.dealers : []),
  shippings: state => (state.shippings ? state.shippings : []),
  shippingRates: state => (state.shippingRates ? state.shippingRates : []),
  linkedCompanies: state => (state.linkedCompanies ? state.linkedCompanies : []),
}

const mutations = {
  [FETCH_START](state) {
    Nprogress.start()
    state.loading = true
  },
  [FETCH_END](state) {
    Nprogress.done()
    state.loading = false
  },
  [SET_DEALERS](state, dealers) {
    state.dealers = dealers
  },
  [SET_SHIPPINGS](state, shippings) {
    state.shippings = shippings
  },
  [SET_SHIPPING_RATES] (state, shippingRates) {
    state.shippingRates = shippingRates
  },
  [SET_LINKED_COMPANIES] (state, linkedCompanies) {
    state.linkedCompanies = linkedCompanies
  },
}

const actions = {
  async [GET_DEALERS]({ dispatch, commit, rootGetters }, id) {
    try {
      commit(FETCH_START)
      if (!rootGetters.store) {
        dispatch(GET_STORE_USER_AUTH)
      }
      const res = await api.get(`store/${rootGetters.store.id || id}/dealers`)
      commit(SET_DEALERS, res.data)
      commit(FETCH_END)
      return res.data
    } catch (err) {
      commit(FETCH_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'error',
        text: err.message
      })
    }
  },
  async [GET_DEALER_DELIVERIES] ({ commit }, dealerId) {
    try {
      commit(FETCH_START)
      const { data } = await api.get(`delivery/${dealerId}`)
      commit(FETCH_END)
      return data
    } catch (err) {
      commit(FETCH_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'error',
        text: err.message
      })
    }
  },
  async [GET_SHIPPINGS]({ commit }) {
    try {
      commit(FETCH_START)
      const res = await api.get(`/delivery`)
      commit(SET_SHIPPINGS, res.data)
      commit(FETCH_END)
      return res.data
    } catch (err) {
      commit(FETCH_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'error',
        text: err.message
      })
    }
  },
  async [GET_SHIPPING_RATES] ({ commit }) {
    try {
      commit(FETCH_START)
      const res = await api.get('/deliveryprices')
      commit(SET_SHIPPING_RATES, res.data)
      commit(FETCH_END)
      return res.data
    } catch (err) {
      commit(FETCH_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'error',
        text: err.message
      })
    }
  },
  async [GET_LINKED_COMPANIES] ({ commit }) {
    try {
      commit(FETCH_START)
      const res = await api.get('/company')
      commit(SET_LINKED_COMPANIES, res.data)
      commit(FETCH_END)
      return res.data
    } catch (err) {
      commit(FETCH_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'error',
        text: err.message
      })
    }
  },
  async [MARK_DELIVERY_AS_PAID] ({commit, dispatch}, delivery){
  try {
    commit(FETCH_START)
    const res = await api.patch(`/delivery/pay/${delivery.bill_id}`)
    await dispatch(GET_SHIPPINGS)
    commit(FETCH_END)
  } catch (err) {
      commit(FETCH_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'error',
        text: err.message
      })
    }
  },
  async [CREATE_DEALER]({ dispatch, commit }, dealer) {
    try {
      commit(FETCH_START)
      const res = await api.post(`/dealer`, dealer)
      await dispatch(GET_DEALERS)
      commit(FETCH_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'success',
        text: '✔️ Repartidor creado exitosamente'
      })
    } catch (err) {
      commit(FETCH_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'error',
        text: '❌ Ha ocurrido un error al crear el repartidor'
      })
    }
  },
  async [UPDATE_DEALER]({ dispatch, commit }, dealer) {
    try {
      commit(FETCH_START)
      const res = await api.patch(`dealer/${dealer.id}`, dealer)
      await dispatch(GET_DEALERS)
      commit(FETCH_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'success',
        text: '✔️ Repartidor actualizado exitosamente'
      })
    } catch (err) {
      commit(FETCH_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'error',
        text: '❌ Ha ocurrido un error al actualizar el repartidor'
      })
    }
  },
  async [DELETE_DEALER]({ dispatch, commit }, dealerId) {
    try {
      commit(FETCH_START)
      const res = await api.delete(`dealer/${dealerId}`)
      await dispatch(GET_DEALERS)
      commit(FETCH_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'success',
        text: '✔️ Repartidor eliminado exitosamente'
      })
    } catch (err) {
      commit(FETCH_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'error',
        text: '❌ Ha ocurrido un error al eliminar el repartidor'
      })
    }
  },
  async [CREATE_SHIPPING_RATE] ({dispatch, commit}, shippingRate) {
    console.log(shippingRate)
    try {
      commit(FETCH_START)
      const res = await api.post('deliveryprices', shippingRate)
      await dispatch(GET_SHIPPING_RATES)
      commit(FETCH_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'success',
        text: '✔️ Ruta creada exitosamente'
      })
    } catch (error) {
      commit(FETCH_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'error',
        text: '❌ Ha ocurrido un error al crear la ruta'
      })
    }
  },
  async [UPDATE_SHIPPING_RATE]({ dispatch, commit }, shippingRate) {
    try {
      commit(FETCH_START)
      const res = await api.patch(`/deliveryprices/${shippingRate.id}`, shippingRate)
      await dispatch(GET_SHIPPING_RATES)
      commit(FETCH_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'success',
        text: '✔️ Ruta actualizada exitosamente'
      })
    } catch (err) {
      commit(FETCH_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'error',
        text: '❌ Ha ocurrido un error al actualizar la ruta'
      })
    }
  },
  async [DELETE_SHIPPING_RATE]({ dispatch, commit }, shippingRateId) {
    try {
      commit(FETCH_START)
      const res = await api.delete(`/deliveryprices/${shippingRateId}`)
      await dispatch(GET_SHIPPING_RATES)
      commit(FETCH_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'success',
        text: '✔️ Ruta eliminada exitosamente'
      })
    } catch (err) {
      commit(FETCH_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'error',
        text: '❌ Ha ocurrido un error al eliminar la ruta'
      })
    }
  },
  async [LINK_DELIVERY_COMPANY] ({ commit, dispatch }, data) {
    try {
      commit(FETCH_START)
      const res = await api.post('/company', data)
      await dispatch(GET_LINKED_COMPANIES)
      commit(FETCH_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'success',
        text: '✔️ La empresa de delivery ha sido vinculada exitosamente'
      })
    } catch (error) {
      commit(FETCH_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'error',
        text: '❌ Ha ocurrido un error al vincular la empresa de delivery'
      })
      
    }
  },
  async [UNLINK_DELIVERY_COMPANY] ({ commit, dispatch }, delivery_company_id) {
    try {
      commit(FETCH_START)
      const res = await api.delete(`/company/${delivery_company_id}`)
      await dispatch(GET_LINKED_COMPANIES)
      commit(FETCH_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'success',
        text: '✔️ La empresa de delivery ha sido desvinculada exitosamente'
      })
    } catch (error) {
      commit(FETCH_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'error',
        text: '❌ Ha ocurrido un error al desvincular la empresa de delivery'
      })
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
